import { EditorHeader } from '@/shared/components/EditorHeader';
import { Skeleton } from '@/shared/components/ui/skeleton';

export function DeviceDetailPendingState() {
  return (
    <div className="flex h-svh flex-col" aria-busy="true">
      <EditorHeader
        start={
          <div className="flex items-center gap-3">
            <Skeleton className="h-8 w-16" />
            <Skeleton className="h-5 w-36" />
            <Skeleton className="h-5 w-16 rounded-full" />
          </div>
        }
        actions={<Skeleton className="h-8 w-32" />}
      />
      <div className="min-h-0 flex-1 overflow-hidden">
        <div className="mx-auto flex max-w-5xl flex-col gap-4 p-4 md:p-6">
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-28 w-full" />
          <div className="space-y-2">
            <Skeleton className="h-6 w-24" />
            <Skeleton className="h-8 w-full" />
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-10 w-full" />
          </div>
        </div>
      </div>
    </div>
  );
}
